import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { LoginService } from 'src/app/Common/Services/login.service';
import { HttpHeaders } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-admin-contact-us',
  templateUrl: './admin-contact-us.component.html',
  styleUrls: ['./admin-contact-us.component.css']
})
export class AdminContactUsComponent implements OnInit {

  contactform:FormGroup;
  
  constructor(private _formbuilder: FormBuilder,public loginservice:LoginService,private toastr: ToastrService) {

    this.contactform =this._formbuilder.group({
      name:['',[Validators.required]],
      mobile:['',[Validators.required,Validators.minLength(10),Validators.pattern('^(0|[0-9][0-9]*)$')]],
      email:['',[Validators.required,Validators.email]],
      message:['',[Validators.required]]
    })
   }

  ngOnInit() {
  }

  submit(contactform){
     
    if(this.contactform.valid){
    let Form = JSON.stringify(this.contactform.value);
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json');
    this.loginservice.contact(Form).subscribe((res: any)=>{
      console.log(res);
       
        if(res.responseBody){
          this.toastr.success(res.responseBody.validationMsg, undefined, {
            positionClass: 'toast-bottom-right',
            timeOut: 6000
       });
        }
    })
    }
    this.contactform.reset();
  }


}
